import axios from 'axios';

import { callApi } from '@src/services/api/helpers';

/**
 * Turn a browser dropped file structure into expected structure
 * */
const file2Attachment = (file) => {
    if (!(file instanceof File)) {
        return file;
    }

    return {
        // eslint-disable-next-line
        file: file,
        display_name: file.name,
        filename: file.name,
    };
};

const attachmentPathname = (attachment) => {
    if (!attachment) return null;

    return `/attachments/${attachment.id}/download`;
};

const frontendAttachmentPathname = (attachment) => {
    if (!attachment) return null;

    return `/attachments?name=${attachment.filename}&id=${attachment.id}`;
};

const uploadToCloud = (files) => Promise.all(files.map((file) => callApi('/attachments/new', {
    params: { filename: file.name },
}).then((response) => {
    const { s3_key_uuid: s3KeyUuid, upload_url: uploadUrl } = response.data.attachment;

    return axios.put(
        uploadUrl,
        file,
        {
            headers: {
                'Content-Type': file.type,
            },
        },
    ).then(() => ({ s3KeyUuid, file }));
}).catch((error) => {
    console.error(error);
    return null;
})));

export {
    attachmentPathname,
    frontendAttachmentPathname,
    file2Attachment,
    uploadToCloud,
};
